// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import VueScrollTo from 'vue-scrollto'
import VueProgressiveImage from 'vue-progressive-image'

Vue.config.productionTip = false
Vue.use(VueScrollTo);
Vue.use(VueProgressiveImage, {
  cache: true,
  blur: 20
}),

/* eslint-disable */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
})


 



// WEBPACK FOOTER //
// ./src/main.js